import { render, staticRenderFns } from "./DashboardItem.vue?vue&type=template&id=2d305f8c&scoped=true"
import script from "./DashboardItem.vue?vue&type=script&lang=js"
export * from "./DashboardItem.vue?vue&type=script&lang=js"
import style0 from "./DashboardItem.vue?vue&type=style&index=0&id=2d305f8c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d305f8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d305f8c')) {
      api.createRecord('2d305f8c', component.options)
    } else {
      api.reload('2d305f8c', component.options)
    }
    module.hot.accept("./DashboardItem.vue?vue&type=template&id=2d305f8c&scoped=true", function () {
      api.rerender('2d305f8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/DashboardItem.vue"
export default component.exports